import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

import admin from './sections/admin'
import capacita from './sections/capacita'
import cocina from './sections/cocina'
import biomedica from './sections/biomedica'
import calidad from './sections/calidad'
import ceye from './sections/ceye'
import cirugia from './sections/cirugia'
import cirugiatv from './sections/cirugiatv'
import consulta from './sections/consulta'
import rhumanos from './sections/rhumanos'
//import drugs from './sections/drugs'
import home from './sections/home'
import internados from './sections/internados'
import lab from './sections/laboratorio'
import lavanderia from './sections/lavanderia'
import mantenimiento from './sections/mantenimiento'
import medicamentos from './sections/medicamentos'
import pacientes from './sections/pacientes'
import presupuestos from './sections/presupuestos'
import principal from './sections/principal'
import rayosx from './sections/rayosx'
import reportes from './sections/reportes'
import trascor from './sections/trascor'
import ortopac from './sections/ortopac'
//import medicamentos from './sections/medicamentos'

const routes = [

    ...admin,
    ...capacita,
    ...cocina,
    ...biomedica,
    ...calidad,
    ...ceye,
    ...cirugia,
    ...cirugiatv,
    ...consulta,
//    ...drugs,
    ...home,
    ...internados,
    ...lab,
    ...lavanderia,
    ...mantenimiento,
    ...medicamentos,
    ...pacientes,
    ...presupuestos,
    ...principal,
    ...rayosx,
    ...rhumanos,
    ...reportes,
    ...trascor,
    ...ortopac,

    {
        path: "*",
        component: () => import(/* webpackChunkName: "noEncontrado" */ '@/views/NoEncontrado.vue')
    }

]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    duplicateNavigationPolicy: 'ignore',
    routes,
})

export default router
